import { render, staticRenderFns } from "./showWordLimit-editor.vue?vue&type=template&id=b6bf0f48&scoped=true&"
import script from "./showWordLimit-editor.vue?vue&type=script&lang=js&"
export * from "./showWordLimit-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6bf0f48",
  null
  
)

export default component.exports